import { obDefaultValGet } from "common/common";
import { sortFieldsGet } from "common/search/search_common";
import { SEARCH_NAMES } from "constant/search/search";

export const characterSearchFieldsGet = (searchFieldOb: any = null) => {
  let result = null;
  if (searchFieldOb === null) {
    result = {
      [SEARCH_NAMES.SEARCH_TEXT]: "",
      [SEARCH_NAMES.SEARCH_ALSO_IN_OTHER_TOPICS]: false,
    };
  } else {
    result = {
      [SEARCH_NAMES.SEARCH_TEXT]: obDefaultValGet(
        searchFieldOb,
        SEARCH_NAMES.SEARCH_TEXT,
        ""
      ),
      [SEARCH_NAMES.SEARCH_ALSO_IN_OTHER_TOPICS]: obDefaultValGet(
        searchFieldOb,
        SEARCH_NAMES.SEARCH_ALSO_IN_OTHER_TOPICS,
        false
      ),
    };
  }

  const sortFields = sortFieldsGet(searchFieldOb);
  result = { ...result, ...sortFields };

  return result;
};
